<template>
  <div></div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'TimerMixin',
  props: {},
  components: {},
  data() {
    return {
      timerAvailableTime: 0,
      timerEndDate: 0,
      timerEndCountdown: 0,
      burnedTime: 0,
      mixinEndCounterInterval: undefined,
    };
  },
  created() {
    this.initComponent();
  },
  beforeDestroy() {
    this.stopEndCountDownInterval();
  },
  watch: {
    getUserTimer() {
      // this.initComponent();
    },
  },
  computed: {
    ...mapGetters({
      getUserTimer: 'users/getUserTimer',
      isTimerAvailable: 'users/isTimerAvailable',
      loggedInUserProfile: 'users/loggedInUserProfile',
    }),
    user() {
      return this.loggedInUserProfile.user;
    },
    isProUserFromMixin() {
      if (!this.user.state || !this.user.state.payment) {
        return false;
      }
      return this.user.state.payment.status;
    },
    userHasSession() {
      return this.timerEndCountdown >= 0;
    },
    needTimer() {
      return this.isTimerAvailable && this.getUserTimer != null;
    },
  },
  methods: {
    ...mapActions({
      syncTimer: 'users/syncTimer',
    }),
    startEndCountDownInterval() {
      if (this.isTimerAvailable) {
        this.mixinEndCounterInterval = setInterval(() => {
          const endCounter = this.countingEndCounter();
          if (endCounter <= 0) {
            this.checkToNeedRefresh().then(() => {
              this.stopEndCountDownInterval();
              if (endCounter == 0) {
                this.$eventBus.initLessons();
              }
            });
          }
        }, 1000);
      }
    },
    stopEndCountDownInterval() {
      window.clearInterval(this.mixinEndCounterInterval);
      this.mixinEndCounterInterval = null;
    },
    formatMsToMinSec(milliseconds) {
      const minutes = Math.floor(milliseconds / 60000);
      const seconds = ((milliseconds % 60000) / 1000).toFixed(0);
      return `${minutes < 10 ? '0' : ''}${minutes}:${
        seconds < 10 ? '0' : ''
      }${seconds}`;
    },
    formatMsToHourMinSec(milliseconds) {
      const millis = Math.abs(milliseconds);
      let seconds = Math.floor(millis / 1000);
      let minutes = Math.floor(seconds / 60);
      seconds %= 60;
      let hours = Math.floor(minutes / 60);
      minutes %= 60;
      hours = hours < 10 ? `0${hours}` : hours;
      minutes = minutes < 10 ? `0${minutes}` : minutes;
      seconds = seconds < 10 ? `0${seconds}` : seconds;

      return `${hours}:${minutes}:${seconds}`;
    },
    initComponent() {
      if (this.needTimer) {
        this.timerAvailableTime = this.getUserTimer.timerAvailableTime;
        this.timerEndDate = this.getUserTimer.timerEndDate;
        this.timerEndCountdown = this.getUserTimer.timerEndCountdown + 1000;
      }
    },
    countingTimer() {
      this.burnedTime += 1;
      this.timerAvailableTime = this.timerAvailableTime - 1000;
      return this.timerAvailableTime;
    },
    countingEndCounter() {
      this.timerEndCountdown = this.timerEndCountdown - 1000;
      return this.timerEndCountdown;
    },
    getEndDateInMs() {
      const now = this.$moment();
      const endDate = this.$moment(this.getUserTimer.timerEndDate);
      const diff = now.diff(endDate, 'seconds') * 1000;
      return diff;
    },
    async checkToNeedRefresh() {
      return new Promise(async (resolve) => {
        // let diff;
        // if (diffProp) {
        //   diff = diffProp;
        // } else {
        //   diff = this.getEndDateInMs();
        // }
        // if (diff >= 0) {
        await this.refreshTimer(-1, false).then((res) => {
          this.initComponent();
          resolve(res);
        });
        // }
      });
    },
    async refreshTimer(burnedTime = undefined, initNewSession = false) {
      return new Promise(async (resolve) => {
        const data = {
          burned_time: burnedTime == null ? this.burnedTime * 1000 : burnedTime,
          init_new_session: initNewSession,
        };
        await this.syncTimer(data).then((res) => {
          resolve(res);
        });
      });
    },
  },
};
</script>
